"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _core = require("@stt-componentes/core");
var _coreV = require("@stt-componentes/core-v2");
var _core2 = require("@material-ui/core");
var _reactDraggable = _interopRequireDefault(require("react-draggable"));
var _iainiciaraviso = _interopRequireDefault(require("./img/iainiciaraviso.gif"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = (0, _styles.makeStyles)(function () {
  return {
    textoIa: {
      position: 'absolute',
      top: 20,
      right: 32,
      padding: 10
    },
    textoInvalidacao: {
      whiteSpace: "pre-line",
      position: 'relative',
      top: 25,
      right: 10,
      padding: 10
    },
    tooltipContent: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "2px"
    },
    wrapperBotao: {
      direction: "row",
      justifyContent: "flex-end",
      alignItems: "center",
      gap: "8px",
      marginTop: "30px"
    },
    containerOculto: {
      display: "none"
    },
    btnFechar: {
      position: 'absolute',
      top: 5,
      right: 5,
      cursor: 'pointer',
      color: '#999'
    }
  };
});
var HtmlTooltip = (0, _styles.withStyles)(function (theme) {
  return {
    tooltip: {
      boxShadow: "4px 4px 4px 2px rgba(158,158,158,0.6)",
      backgroundColor: '#fefefe',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 750,
      borderRadius: 12,
      padding: 25,
      fontSize: theme.typography.pxToRem(12),
      border: "1px solid #dadde9",
      alignItems: "left",
      flexDirection: "column"
    },
    arrow: {
      "&:before": {
        border: "1px solid #E6E8ED",
        borderRadius: 3,
        boxShadow: '4px 2px 4px 2px rgba(158, 158, 158, 0.6)'
      },
      color: theme.palette.common.white,
      fontSize: 'xx-large',
      bottom: '1px !important'
    }
  };
})(_core2.Tooltip);
var timeout = null;
var SttIa = function SttIa(props) {
  var classes = useStyles();
  var strings = props.strings,
    exame = props.exame,
    botoes = props.botoes,
    mensagens = props.mensagens;
  var STORAGE_KEY = 'posicao_stt_ia';
  var _useState = (0, _react.useState)(function () {
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        if (raw) {
          var parsed = JSON.parse(raw);
          return {
            x: Number(parsed.x) || 0,
            y: Number(parsed.y) || 0
          };
        }
      } catch (e) {}
      return {
        x: 0,
        y: 0
      };
    }),
    _useState2 = _slicedToArray(_useState, 2),
    axis = _useState2[0],
    setAxis = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    motivo = _useState4[0],
    setMotivo = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    protocolo = _useState6[0],
    setProtocolo = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    oculto = _useState8[0],
    setOculto = _useState8[1];
  var containerOcultar = function containerOcultar() {
    setOculto(true);
  };
  (0, _react.useEffect)(function () {
    if (exame.exame.reason) {
      setMotivo(exame.exame.reason);
      setProtocolo(true);
    } else {
      setMotivo([]);
      setProtocolo(false);
    }
  }, [exame]);
  if (!protocolo || oculto) return null;
  return /*#__PURE__*/_react["default"].createElement(_reactDraggable["default"], {
    bounds: "html",
    position: axis,
    onDrag: function onDrag(e, _ref) {
      var lastX = _ref.lastX,
        lastY = _ref.lastY,
        x = _ref.x,
        y = _ref.y;
      if (timeout) {
        clearTimeout(timeout);
      }
      timeout = setTimeout(function () {
        var currX = (lastX !== undefined ? lastX : x) || 0;
        var currY = (lastY !== undefined ? lastY : y) || 0;
        var diffX = Math.abs(axis.x - currX);
        var diffY = Math.abs(axis.y - currY);
        if (diffX < 0.6 && diffY < 0.6) {
          return false;
        } else {
          setAxis({
            x: currX,
            y: currY
          });
        }
      }, 10);
    },
    onStop: function onStop(e, _ref2) {
      var lastX = _ref2.lastX,
        lastY = _ref2.lastY,
        x = _ref2.x,
        y = _ref2.y;
      var nx = (lastX !== undefined ? lastX : x) || 0;
      var ny = (lastY !== undefined ? lastY : y) || 0;
      setAxis({
        x: nx,
        y: ny
      });
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
          x: nx,
          y: ny
        }));
      } catch (err) {
        // ignore
      }
    }
  }, /*#__PURE__*/_react["default"].createElement(HtmlTooltip, {
    arrow: true,
    placement: "right-start",
    interactive: true,
    title: /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.tooltipContent
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.btnFechar,
      onClick: containerOcultar
    }, /*#__PURE__*/_react["default"].createElement(_Close["default"], null)), /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
      container: true,
      spacing: 3
    }, /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
      item: true
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.textoIa
    }, /*#__PURE__*/_react["default"].createElement(_core.SttHeading, {
      variant: "h3",
      color: "primary"
    }, strings.iaStt)), /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.textoInvalidacao
    }, /*#__PURE__*/_react["default"].createElement(_core.SttText, {
      variant: "h4",
      color: "primary"
    }, mensagens.join('\n'))))), /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
      item: true,
      container: true,
      className: classes.wrapperBotao
    }, botoes === null || botoes === void 0 ? void 0 : botoes.map(function (btn) {
      return /*#__PURE__*/_react["default"].createElement(_coreV.SttButton, {
        variant: btn.variant,
        color: "primary",
        onClick: btn.onClick
      }, btn.rotulo);
    })))
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: _iainiciaraviso["default"],
    width: 100,
    draggable: false,
    alt: "Icone IA"
  })));
};
var _default = SttIa;
exports["default"] = _default;